// @core/api/endpoints/tenant/delete_tenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/tenant';

/**
 * Delete tenant
 * Permanently deletes a tenant and all associated data. This action is irreversible and requires owner privileges. Use with caution.
 */
export async function DeleteTenant(
  tenant_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
